import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import BaseField from 'components/Field';

interface StyledProps {
  $isDirty?: boolean;
}

export const Wrapper = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    height: 100vh;
  }
`;

export const FormContainer = styled(Form)<StyledProps>`
  padding: ${({ $isDirty }) => ($isDirty ? '0px 16px 132px 16px' : '0px 16px 32px 16px')};
  overflow-x: hidden;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
  }
`;

export const Container = styled.section`
  height: auto;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    padding-bottom: 40px;
  }
`;

export const Line = styled.div`
  width: 100%;
  padding-top: 32px;
  height: 1px;
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};

  @media ${({ theme }) => theme.device.mobile} {
    margin-left: -16px;
    width: calc(100% + 32px);
  }
`;

export const Field = styled(BaseField)`
  margin-bottom: 16px;
`;

export const Title = styled.h4`
  font-size: 24px;
  font-weight: 600;
  margin: 32px 16px 16px;
  line-height: 1.33;
  letter-spacing: -0.4px;
  color: ${ColorPalette.HEX.PineTree};

  @media ${({ theme }) => theme.device.desktop} {
    margin: 32px 0 16px 0;
  }
`;

export const MapBox = styled.div`
  height: 287px;
  width: 100%;
  margin-bottom: 16px;
`;

export const Address: any = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    margin: 0 16px;
  }
`;

Address.Title = styled.div`
  padding: 16px 0 8px;
  font-size: 14px;
  line-height: 20px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
